
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import { ProfileHeader } from "./ProfileHeader";
import { ProfileHeaderProps } from "./types";

export const ProfileHeaderSection = ({ profile, onUpload }: ProfileHeaderProps) => {
  return (
    <>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-3xl font-bold">Profile</h1>
          <p className="text-muted-foreground mt-1">
            Manage your personal information and preferences
          </p>
        </div>
        <Badge variant="secondary" className="text-sm">
          {profile.profile_completion_percentage}% Complete
        </Badge>
      </div>

      <Progress value={profile.profile_completion_percentage} className="mb-6" />

      <ProfileHeader
        coverPhoto={profile.cover_photo}
        profilePic={profile.profile_pic}
        onUpload={onUpload}
      />
    </>
  );
};
